export const LEFT_COLUMN_WIDTH = 480
export const FIT_COLUMN_WIDTH = 260
export const AXIS_HEIGHT = 48
export const SERVICE_ROW_HEIGHT = 80
export const FIT_SERVICE_ROW_HEIGHT = 40
export const VENDOR_ROW_HEIGHT = 44
export const DAY_WIDTH = 100
export const MIN_FIT_DAY_WIDTH = 36
